import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import "./Navbar.css";
import Nav from "../assets/Logo.webp";

// TODO: replace each href with Sippy Films' real profile URL.
const SOCIAL_LINKS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/sippyfilms",
    icon: (
       <svg className="social-icon" viewBox="0 0 24 24"><path d="M22.675 0h-21.35C.595 0 0 .593 0 1.325v21.351C0 23.407.595 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.593 1.323-1.325V1.325C24 .593 23.407 0 22.675 0z"/></svg>

    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/sippyfilms/",
    icon: (
       <svg className="social-icon" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>

    ),
  },
  
  {
    label: "YouTube",
    href: "https://www.youtube.com/@sippyfilms",
    icon: (
         <svg className="social-icon" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
    ),
  },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Case-insensitive so "/News" and "/news" both highlight NEWS.
  const isActive = (path) => location.pathname.toLowerCase() === path.toLowerCase();

  const close = () => setOpen(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <Link to="/" onClick={close}>
        <img src={Nav} alt="Sippy Films Logo" className="nav-logo" />
      </Link>

      {/* Hamburger (mobile only) */}
      <button
        className={`nav-toggle ${open ? "open" : ""}`}
        onClick={() => setOpen(!open)}
        aria-label="Toggle navigation menu"
        aria-expanded={open}
      >
        <span />
        <span />
        <span />
      </button>

      {/* Desktop: page links sit beside the logo, social icons are pushed right.
          Mobile: this whole block becomes the slide-in drawer. */}
      <div className={`nav-menu ${open ? "show" : ""}`}>
        <ul className="nav-links">
          <li onClick={close}>
            <Link to="/about-us" className={isActive("/about-us") ? "active" : ""}>
              ABOUT
            </Link>
          </li>
          <li onClick={close}>
            <Link to="/movies" className={isActive("/movies") ? "active" : ""}>
              FILMS
            </Link>
          </li>
          <li onClick={close}>
            <Link to="/News" className={isActive("/News") ? "active" : ""}>
              NEWS
            </Link>
          </li>
          <li onClick={close}>
            <Link to="/contact" className={isActive("/contact") ? "active" : ""}>
              CONTACT
            </Link>
          </li>
        </ul>

        <ul className="nav-social" aria-label="Social media">
          {SOCIAL_LINKS.map(({ label, href, icon }) => (
            <li key={label}>
              <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                {icon}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}